import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import _ from "lodash";

const FilterDropdown = ({
  icon,
  menuItems,
  onSelect,
  type = "default",
  supportingText = false,
  hierarchy = "secondaryGrey",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const [selectedItem, setSelectedItem] = useState(null);
  const dropdownRef = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionSelect = (item) => {
    setSelectedItem(item);
    onSelect(item);
    setIsOpen(false);
  };

  return (
    <div className="dropdownButtonContainer" ref={dropdownRef}>
      {/* The IconButton */}
      <button className={`iconButton ${hierarchy}`} onClick={handleToggleDropdown}>
        {icon}
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <ul className="inputDropdownMenuList">
          {_.map(menuItems, (item, index) => {
            // Fallbacks for label and value
            const label = item.roletitle || "No Title";
            const value = item.roletitle
              ? item.roletitle.toLowerCase().replace(/\s+/g, "-")
              : `no-value-${index}`;

            return (
              <li
                id={value}
                key={index}
                onClick={() => handleOptionSelect({ label, value })}
                onMouseOver={() => setFocusedIndex(index)}
                className={`inputDropdownMenuItem${label === selectedItem?.label && value === selectedItem?.value
                  ? " selected"
                  : ""
                  }${focusedIndex === index ? " focusedItem" : ""}`}
              >
                <div className="inputDropdownMenuItemContent">
                  <p className="inputDropdownMenuItemLabel">{label}</p>
                  {supportingText && (
                    <span className="inputDropdownMenuItemSupportText">
                      {item.supportingText || ""}
                    </span>
                  )}
                </div>
                {label === selectedItem?.label &&
                  value === selectedItem?.value && (
                    <svg
                      className="inputDropdownMenuItemIcon tickIcon"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.6668 5L7.50016 14.1667L3.3335 10"
                        stroke="#F55533"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

FilterDropdown.propTypes = {
  icon: PropTypes.element.isRequired,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      roletitle: PropTypes.string,
      supportingText: PropTypes.string,
    })
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  type: PropTypes.string,
  supportingText: PropTypes.bool,
  hierarchy: PropTypes.string,
};

export default FilterDropdown;
